import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import Typography from "@mui/material/Typography";
import { Alert, Box, Grid, ToggleButton, ToggleButtonGroup, Stack, Button, Menu, MenuItem, 
          FormControl, FormControlLabel, InputLabel, Checkbox, useTheme, Select, Snackbar } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CircularProgress from '@mui/material/CircularProgress';
import DatePickerValue from "../../../components/DatePicker";
import { projectManageAxios as axios } from '../../../utils/AxiosUtility';
import { externalApiAxios as hsAxios } from '../../../utils/AxiosUtility';
import DeviceConfig from "./DeviceConfiguration/DeviceConfig";
import ContractReceived from "./ContractReceived";
import { OpenClosePreSaleButton } from "./OpenClosePreSaleButton";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalScale={2}
      fixedDecimalScale
      thousandSeparator
      valueIsNumericString
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export function PreSalesTask(props) {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);

  const [project, setProject] = useState(null);
  const [projectId, setProjectId] = useState();
  const [taskStatus, setTaskStatus] = useState("Closed");
  const [taskID, setTaskID] = useState("");
  const [pm, setPM] = useState("Allen Yokom");
  const [acknowledgement, setAcknowledgement] = useState(false);
  const [siteVisit, setSiteVisit] = useState(false);
  const [siteVisitDate, setSiteVisitDate] = useState(null);
  const [siteVisitCom, setSiteVisitCom] = useState(false);
  const [siteVisitComDate, setSiteVisitComDate] = useState(null);
  const [approval, setApproval] = useState(false);
  // eslint-disable-next-line
  const [preApproval, setPreApproval] = useState(false);
  const [finalApproval, setFinalApproval] = useState(false);
  const [prelimDesign, setPrelimDesign] = useState(false);
  const [finalDesign, setFinalDesign] = useState(false);
  const [contract, setContract] = useState(false);
  const [unitConfig, setUnitConfig] = useState(0);
  const [units, setUnits] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [selectedFinalDesign, setSelectedFinalDesign] = useState("None");
  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const [siteVisitChecked, setSiteVisitChecked] = useState(false);
  const [designsChecked, setDesignsChecked] = useState(false);
  const [fieldEngApprovalChecked, setFieldEngApprovalChecked] = useState(false);
  const [preSaleStatusListener, setPreSaleStatusListener] = useState(0);
  const theme = useTheme();
  let location = useLocation();

  // eslint-disable-next-line
  const [updatedChanges, setUpdatedChanges] = useState({
    "acknowledgementDate": null,
    "pmAssigned": null,
    "corpApprovalDate": null,
    "contractReceived": null,
    "centralStation" : null,
    "csAccountManager" : null,
  });

const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
};

const handleClose = () => {
    setAnchorEl(null);
};

const handleCheckboxChange = (option) => {

    if (option === "Site Visit") {
        setSiteVisitChecked(!siteVisitChecked);
    }
    else if (option === "Designs") {
        setDesignsChecked(!designsChecked);
    }
    else if (option === "Field Eng Approval") {
        setFieldEngApprovalChecked(!fieldEngApprovalChecked);
    };
};

const outlineColor = theme.palette.mode === "dark" ? "white" : "red";
const isOpen = Boolean(anchorEl);

  useEffect(() => {
    setProjectId(searchParams.get("id"));
  }, [searchParams]);

  const handleAckChange = (event, ack) => {
    if (ack !== null) {
      setAcknowledgement(ack);
      setUpdatedChanges((prevState) => ({
        ...prevState,
        "acknowledgementDate": "true",
      }));
    }
  };

  const handlePmSelect = (event) => {
    setPM(event.target.value);
    setUpdatedChanges((prevState) => ({
      ...prevState,
      "pmAssigned": "true",
    }));
  };

  const handleSiteChange = (event, site) => {
    if (site !== null) {
      setSiteVisit(site);
      setShowDatePicker(site === true);
    }
  };

  const handleSiteComChange = (event, site) => {
    if (site !== null) {
      setSiteVisitCom(site);
      setSiteVisitComDate(new Date());
    }
  };

  const handlePrelimDesign = (event, design) => {
    if (design !== null) {
      setPrelimDesign(design);
    }
  };

  const handleFinalDesign = (event) => {
    if (event !== null) {
      setSelectedFinalDesign(event.target.value);
    }
  };

  const handlePreApproval = (event, approval) => {
    if (approval !== null) {
      setPreApproval(approval);
    }
  };

  const handleFinalApproval = (event, approval) => {
    if (approval !== null) {
      setFinalApproval(approval);
      setUpdatedChanges((prevState) => ({
        ...prevState,
        "corpApprovalDate": approval ? new Date() : null,
      }));
    }
  };

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };

  const handleContractReceived = async (contractData) => {
    if (contractData.contractReceived) {
      try {

        await handleSubmit(contractData);

        const contractReceivedData = {
          preLeadId: searchParams.get("id"),
          dealStatus: "Contracted"
        };

        await hsAxios.patch("/api/HubSpot/updateDealInfo", contractReceivedData);

        setShowSnackbar(true);
      } catch (error) {
        alert(error.message);
      }
    }
  };

  const handleSubmit = (contractData) => {
    const updatedTask = {
      ...contractData,
      preSaleTaskId: taskID,
      preLeadId: searchParams.get("id"),
      acknowledgementDate: acknowledgement ? new Date(new Date().getTime()) : null,
      pmAssigned: pm ?? "Allen Yokom",
      siteVisitReq: Boolean(siteVisitChecked & siteVisit) ?? false,
      siteVisitDate: siteVisitDate ?? null,
      siteVisitComplete: Boolean(siteVisitChecked & siteVisitCom) ?? null,
      siteVisitCompleteDate: siteVisitComDate,
      finalDesign: selectedFinalDesign !== "None" && selectedFinalDesign !== null ? true : false,
      finalDesignDate: finalDesign ? new Date(new Date().getTime()) : null,
      pEngineerApprover: pm ?? "Allen Yokom",
      pEngineerApprovedDate: fieldEngApprovalChecked & preApproval ? new Date(new Date().getTime()) : null,
      fEngineerApprover: pm ?? "Allen Yokom",
      fEngineerApprovedDate: approval ? new Date(new Date().getTime()) : null,
      corpApproval: finalApproval ?? false,
      corpApprovalDate: updatedChanges.corpApprovalDate,
    };

    axios.post("/api/PreSales/updatePsTask", updatedTask)
      .then((response) => {
        props.onObTaskSubmit(true);
        setShowSnackbar(true);
      })
      .catch((error) => {
        alert(error.message);
      });

    if (selectedFinalDesign === "None" || selectedFinalDesign == null) {
      axios.post("/api/Onboarding/clearFinalDesign")
      .then((response) => {
        setShowSnackbar(true);
      })
      .catch((error) => {
        alert("Error clearing the final design.");
      });
    }
    else {
      const selectedDocument = documentList.find(doc => doc.documentLink === selectedFinalDesign);

      axios.post(`/api/Onboarding/setFinalDesign/${selectedDocument.siteDocumentId}`)
      .then((response) => {
        setShowSnackbar(true);
      })
      .catch((error) => {
        alert("Error setting the final design.");
      });
    }

    let dealInfoToUpload = {
      "preLeadId": updatedTask.preLeadId,
      "dealStatus": updatedTask.dealStatus ?? "Open",
      "dealStatusNotes": updatedTask.dealStatusNotes ?? "",
    }

    hsAxios.patch("/api/HubSpot/updateDealInfo", dealInfoToUpload)
      .then((response) => {
        setShowSnackbar(true);
      })
      .catch((error) => {
        alert("Error updating task in Hubspot.");
      });

    let taskInfoToUpload = {
      "preLeadId": updatedTask.preLeadId,
      "acknowledgementDate": updatedTask.acknowledgementDate ?? null,
      "pmAssigned": acknowledgement ? updatedTask.pmAssigned : null,
      "siteVisitDate": siteVisitChecked & siteVisit ? updatedTask.siteVisitDate : null,
      "pEngineerApprovedDate": updatedTask.pEngineerApprovedDate ?? null
    }

    hsAxios.patch("/api/HubSpot/updateTaskInfo", taskInfoToUpload)
      .then((response) => {
        setShowSnackbar(true);
      })
      .catch((error) => {
        alert("Error updating task in Hubspot.");
      });
  };

  const availablePMs = [
    {
      id: 0,
      name: "Allen Yokom",
    },
    {
      id: 1,
      name: "Kiley Galesewicz",
    },
    {
      id: 2,
      name: "Maurice Johnson",
    },
    {
      id: 3,
      name: "Roman Dowhaniuk",
    },
  ]

  const filteredDocuments = documentList.filter(doc =>
    ['Preliminary Design', 'Major Change', 'Minor Change'].includes(doc.fileType)
  );

  const offsetDate = (date) => {
    return date ? new Date(date.getTime() - (date.getTimezoneOffset() * 60000)) : null;
  }

  const loadParams = (project) => {
    setTaskID(project["preSaleTaskId"]);
    if (project["siteVisitReq"] === true) {
      if (project["siteVisitCompleteDate"]) {
        setSiteVisitComDate(project["siteVisitCompleteDate"] ? offsetDate(new Date(project["siteVisitCompleteDate"])) : null);
      }
      if (project["siteVisitDate"]) {
        setSiteVisitDate(project["siteVisitDate"] ? offsetDate(new Date(project["siteVisitDate"])) : null);
      }
      setSiteVisitCom(project["siteVisitCompleteDate"] ? true : false);
      setSiteVisit(true);
      setShowDatePicker(true);
      setSiteVisitChecked(true);
    }
    else if (project["siteVisitReq"] === false) {
      setSiteVisit(false);
    }
    setAcknowledgement(project["acknowledgementDate"] ? true : false);
    setApproval(project["fEngineerApprovedDate"] ? true : false);
    setPreApproval(project["pEngineerApprovedDate"] ? true : false);
    setFieldEngApprovalChecked(project["pEngineerApprovedDate"] ? true : false);
    setFinalApproval(project["corpApprovalDate"] ? true : false);
    setUpdatedChanges((prevState) => ({
      ...prevState,
      "corpApprovalDate": project["corpApprovalDate"] ?? null,
    }));
    setPrelimDesign(project["prelimDesign"] ? true : false);
    setDesignsChecked(project["prelimDesign"] ? true : false);
    setFinalDesign(project["finalDesign"] ? true : false);
    setContract(project["contractReceived"] ? true : false);
    setPM(project["pmAssigned"]);
    setProject(project);
    setLoading(false);
  };

  const loadFinalDesign = (documents) => {
    documents.forEach(doc => {
      if (doc.finalDesignDoc) {
        setSelectedFinalDesign(doc.documentLink);
      }
    });
  };  

  const loadUnits = (dbUnits) => {
    let i = 0
    setUnitConfig(dbUnits.length);
    let unitSets = [];
    dbUnits.forEach(unit => {
      let zones = [];
      let onlyZones = [];

      unitSets.push({
        name: unit.productName ?? "Unit " + (i + 1),
        type: unit.productType,
        id: unit.productId,
        projectId: searchParams.get("id"),
        value: i,
        riser: unit.productConfigurationDTOs[0].riserCount ?? 0,
        panel: unit.productConfigurationDTOs[0].panelCount ?? 0,
        coldPack: unit.productConfigurationDTOs[0].coldWeatherPackage ?? false,
        detectZone: zones.length,
        detectType: zones,
        currentType: 0,
        detectOZone: onlyZones.length,
        detectOType: onlyZones,
        currentOType: 0,
        power: unit.productConfigurationDTOs[0].powerType,
        riserIL: unit.productConfigurationDTOs[0].riserIndicatorLight ?? false,
        mast: unit.productConfigurationDTOs[0].mastOption ?? false,
        conveyor: unit.productConfigurationDTOs[0].conveyorStop ?? false,
        viewStation: unit.productConfigurationDTOs[0].viewingStation ?? 0,
        ptp: unit.productConfigurationDTOs[0].pointToPoint ?? false,
        thermal: unit.productConfigurationDTOs[0].thermalCameraCount ?? 0,
        flame: unit.productConfigurationDTOs[0].flameDetectorCount ?? 0,
        smoke: unit.productConfigurationDTOs[0].smokeDetectorCount ?? 0,
        eButton: unit.productConfigurationDTOs[0].ebuttonCount ?? 0,
        fd: unit.productConfigurationDTOs[0].fdConnects ?? false,
        interconnect: unit.productConfigurationDTOs[0].interconnect ?? false,
        international: unit.productConfigurationDTOs[0].international ?? false,
        primary4G: unit.productConfigurationDTOs[0]._4gPrimary ?? false,
        f500: unit.productConfigurationDTOs[0].f500Count ?? 0
      });
      i++;
    });
    setUnits(unitSets);
  }

  const fetchDocuments = () => {
    axios
      .get(`/api/PreSales/documentList/${searchParams.get("id")}`)
      .then((response) => {
        const documents = Array.isArray(response.data)
          ? response.data
          : [];
        setDocumentList(documents);
        loadFinalDesign(documents);
      })
      .catch((error) => {
        if (error.message) {
          alert(error.message);
        } else {
          alert("Error fetching document list.");
        }
      });
  };

  useEffect(() => {
    fetchDocuments();
    // eslint-disable-next-line
  }, []);

  const fetchData = () => {
    const endpoint = 'api/PreSales/pstask/' + searchParams.get("id");
    setLoading(true);
    axios.get(endpoint)
      .then((response) => {
        loadParams(response.data);
        const endpoint = 'api/PreSales/products/' + searchParams.get("id");
        axios.get(endpoint)
          .then((response) => {
          loadUnits(response.data);
          })
          .catch((error) => {
            alert("Error retreiving products.");
          });
        const leadEndpoint = 'api/PreSales/pslead/' + searchParams.get("id");
        axios.get(leadEndpoint)
          .then((response) => {
          setTaskStatus(response.data.dealStatus);
          })
          .catch((error) => {
            alert("Error retreiving deal status.");
          });
      })
      .catch((error) => {
        alert("Error retreiving pre-sale data.");
      });
    
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [preSaleStatusListener]);

  return (
    <>
      {loading ?
        <Box sx={{ minHeight: "1137px" }} justifyContent="center" alignContent="center">
          <CircularProgress variant="indeterminate" />
        </Box>
        :
        <>
          <Typography variant="h5" align="center" gutterBottom>
              Tasks
          </Typography>

          <Grid item xs={12} style={{ paddingBottom: '5%' }}>
            <Stack direction="row" alignItems="center">
              <Typography
                variant="h6"
                style={{ minWidth: '35%' }}
              >
                Acknowledgment
              </Typography>

              <Box style={{ flexGrow: '1', minWidth: '60%' }}>
                <ToggleButtonGroup
                  color="primary"
                  value={acknowledgement}
                  exclusive
                  onChange={handleAckChange}
                  aria-label="Ack"
                  sx={{ paddingRight: "10%" }}
                >
                  <ToggleButton color="success" value={true}>Yes</ToggleButton>
                  <ToggleButton value={false}>No</ToggleButton>
                </ToggleButtonGroup>

                {acknowledgement
                  &&
                  <FormControl sx={{ width: "40%" }}>
                    <InputLabel id="pm-label">PM</InputLabel>
                    <Select
                      labelId="pm-label"
                      id="pm-select"
                      value={pm}
                      label="Unit"
                      onChange={handlePmSelect}
                      sx={{ padding: '0px', maxHeight: "45px" }}
                    >
                      {availablePMs.map((pm) => (
                        <MenuItem key={pm.id} value={pm.name}>
                          {pm.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                }
              </Box>


            </Stack>
          </Grid>

          <Grid item xs={12} style={{ paddingBottom: '5%' }}>
            <Box>
              <Button
                variant="outlined"
                onClick={handleClick}
                sx={{
                  color: outlineColor,
                  borderColor: outlineColor,
                  "&:hover": {
                      borderColor: outlineColor,
                  },
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                Additional Tasks
                <KeyboardArrowDownIcon
                    sx={{
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                    }}
                />
              </Button>
              <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
                {["Site Visit", "Designs", "Field Eng Approval"].map((option) => (
                  <MenuItem key={option}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={option === "Designs" && prelimDesign}
                          onChange={() => handleCheckboxChange(option)}
                          checked={(option === "Site Visit" && siteVisitChecked) || 
                                    (option === "Designs" && designsChecked) || 
                                    (option === "Field Eng Approval" && fieldEngApprovalChecked)}
                          sx={{
                            color: outlineColor,
                            "&.Mui-checked": {
                              color: outlineColor,
                            },
                          }}
                        />
                      }
                      label={option}
                      sx={{ color: outlineColor }} 
                    />
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Grid>

          {siteVisitChecked &&
            <>
              <Grid item xs={12} style={{ paddingBottom: '5%' }}>
                <Stack direction="row" alignItems="center">
                  <Typography
                    variant="h6"
                    style={{ minWidth: '35%' }}
                  >
                    Site Visit
                  </Typography>
    
                  <Box style={{ flexGrow: '1', minWidth: '60%' }}>
                    <ToggleButtonGroup
                      color="primary"
                      value={siteVisit}
                      exclusive
                      onChange={handleSiteChange}
                      aria-label="Site Visit"
                      sx={{ paddingRight: "10%" }}
                    >
                      <ToggleButton color="success" value={true}>Yes</ToggleButton>
                      <ToggleButton value={false}>No</ToggleButton>
                    </ToggleButtonGroup>
    
                    {showDatePicker
                      &&
                      !siteVisitCom
                        ?
                        <DatePickerValue onChange={setSiteVisitDate} value={siteVisitDate} label={"Scheduled Visit Date"} />
                        :
                        <DatePickerValue onChange={setSiteVisitDate} value={siteVisitDate} disabled label={"Scheduled Visit Date"} />
                    }
                  </Box>
                </Stack>
              </Grid>
    
              {showDatePicker && 
                <Grid item xs={12} style={{ paddingBottom: '5%' }}>
                  <Stack direction="row" alignItems="center">
                    <Typography
                      variant="h6"
                      style={{ minWidth: '35%' }}
                    >
                      Site Visit Completed
                    </Typography>
    
                    <Box style={{ flexGrow: '1', minWidth: '60%' }}>
                      <ToggleButtonGroup
                        color="primary"
                        value={siteVisitCom}
                        exclusive
                        onChange={handleSiteComChange}
                        aria-label="Site Visit Completed"
                        sx={{ paddingRight: "10%" }}
                      >
                        <ToggleButton color="success" value={true}>Yes</ToggleButton>
                        <ToggleButton value={false}>No</ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Stack>
                </Grid>
              }
            </>
          }

          {designsChecked &&
            <>
              <Grid item xs={12} style={{ paddingBottom: '5%' }}>
                <Stack direction="row" alignItems="center">
                  <Typography
                    variant="h6"
                    style={{ minWidth: '35%' }}
                  >
                    Preliminary Design
                  </Typography>

                  <ToggleButtonGroup
                    color="primary"
                    value={prelimDesign}
                    exclusive
                    onChange={handlePrelimDesign}
                    disabled
                    aria-label="PreDesign"
                    style={{ flexGrow: '1', minWidth: '60%' }}
                  >
                    <ToggleButton color="success" value={true}>Yes</ToggleButton>
                    <ToggleButton value={false}>No</ToggleButton>
                  </ToggleButtonGroup>
                </Stack>
              </Grid>

              <Grid item xs={12} style={{ paddingBottom: '5%' }}>
                <Stack direction="row" alignItems="center">
                  <Typography
                    variant="h6"
                    style={{ minWidth: '35%' }}
                  >
                    Final Design
                  </Typography>

                  <FormControl sx={{ width: "40%" }}>
                    <InputLabel id="finalDesign-label">Final Design</InputLabel>
                    <Select
                      labelId="finalDesign-label"
                      id="finalDesign-select"
                      value={selectedFinalDesign}
                      label="Final Design"
                      onChange={handleFinalDesign}
                      sx={{ padding: '0px', maxHeight: "45px" }}
                    >
                      <MenuItem key={0} value={"None"}>None</MenuItem>
                      {filteredDocuments.map((doc) => (
                        <MenuItem key={doc.id} value={doc.documentLink}>
                          {`${doc.fileType} ${doc.versionNo}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                </Stack>
              </Grid>
            </>
          }

          {fieldEngApprovalChecked &&
            <Grid item xs={12} style={{ paddingBottom: '5%' }}>
              <Stack direction="row" alignItems="center">
                <Typography
                  variant="h6"
                  style={{ minWidth: '35%' }}
                >
                  Prelim Eng Approval
                </Typography>

                <ToggleButtonGroup
                  color="primary"
                  value={preApproval}
                  exclusive
                  onChange={handlePreApproval}
                  aria-label="Apr"
                  style={{ flexGrow: '1', minWidth: '60%' }}
                >
                  <ToggleButton color="success" value={true}>Yes</ToggleButton>
                  <ToggleButton value={false}>No</ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Grid>
          }

          <Grid item xs={12} style={{ paddingBottom: '5%' }}>
              <DeviceConfig isProject={false} />
          </Grid>

          <Grid item xs={12} style={{ paddingBottom: '5%' }}>
            <Stack direction="row" alignItems="center">
              <Typography
                variant="h6"
                style={{ minWidth: '35%' }}
              >
                Corporate Approval
              </Typography>

              <ToggleButtonGroup
                color="primary"
                value={finalApproval}
                exclusive
                onChange={handleFinalApproval}
                aria-label="Final Approval"
                style={{ flexGrow: '1', minWidth: '60%' }}
              >
                <ToggleButton color="success" value={true}>Yes</ToggleButton>
                <ToggleButton value={false}>No</ToggleButton>
              </ToggleButtonGroup>
            </Stack>
          </Grid>

          <ContractReceived isContractReceived={handleContractReceived} Contract={contract} siteData={props.siteData} />

          <Grid item xs={12} style={{ paddingBottom: "1%" }}>
            <Box display="flex" justifyContent="space-between">
              <OpenClosePreSaleButton preleadId={searchParams.get("id")} listener={preSaleStatusListener} setListener={setPreSaleStatusListener}/>
              <Button variant="contained" disabled={taskStatus !== "Open"} onClick={() => {handleSubmit(contract)}}>Save</Button>
            </Box>
          </Grid>

          <Snackbar
            open={showSnackbar}
            autoHideDuration={5000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              Saved Successfully!
            </Alert>
          </Snackbar>
        </>
      }
    </>
  );
}
